export enum ETraitementTags {
	/** Hospitalisation à domicile. */
	HAD = "HAD",
	/** Service de soins infirmiers à domicile. */
	SSIAD = "SSIAD"
}